import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { SharedService } from '../services/shared.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const configService = inject(ConfigService);
  const sharedService = inject(SharedService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const companyCode =
          sharedService.getCookie('companycode') ||
          sharedService.getCookie('clientCode') ||
          '';
        const query = new URLSearchParams({
          returnUrl: window.location.href,
        });
        if (companyCode) {
          query.set('companyCode', companyCode);
        }
        window.location.replace(
          `${configService.getApiUrl('ssoUrl')}account/login?${query.toString()}`
        );
      }

      return throwError(() => error);
    })
  );
};
